import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import moment from 'moment';

interface IEstoque {
  idprod: string;
  descricao: string;
  ean: string;
  codfabrica: string;
  valor: number;
  estoque: number;
  total: number;
}

async function Relatorioestoque(dados: IEstoque[], nome: string) {
  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  if (dados.length === 0) {
    console.error('Nenhum dado disponível para gerar o relatório.');
    return;
  }

  // Calcula o total de vendas
  const TValorVendas = dados.reduce((acc, item) => acc + (item.total || 0), 0);
  const TQuantidade = dados.reduce((acc, item) => acc + (item.estoque || 0), 0);
  const TItens = dados.length;


  // Mapeia os dados para criar a tabela
  const vendas = dados.map(({ ean, descricao, codfabrica, valor, estoque, total }) => [
    { text: ean || '-', alignment: 'left', fontSize: 8 },
    { text: codfabrica || '-', alignment: 'left', fontSize: 8 },
    { text: descricao || '-', alignment: 'center', fontSize: 8 },
    { text: new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(estoque || 0), alignment: 'center', fontSize: 8 },
    { text: new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(valor || 0), alignment: 'center', fontSize: 8 },
    { text: new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(total || 0), alignment: 'right', fontSize: 8 },
  ]);

  // Função para converter imagens em base64
  async function getBase64ImageFromUrl(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = function () {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject('Erro ao obter o contexto 2D');
          return;
        }
        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL('image/png'));
      };
      img.onerror = function () {
        reject(`Erro ao carregar a imagem: ${url}`);
      };
      img.src = url;
    });
  }

  // Carrega a imagem do logo
  const imageUrl = process.env.REACT_APP_URL_IMAGLOG || '';
  let imageData = '';
  try {
    imageData = await getBase64ImageFromUrl(imageUrl);
  } catch (error) {
    console.error('Erro ao carregar a imagem do logo:', error);
  }

  const documentDefinition: any = {
    pageSize: 'A4',
    pageMargins: [20, 10, 20, 10],
    pageOrientation: 'portrait',
    header: { text: 'Relatório de Estoque', alignment: 'center', fontSize: 10, margin: [0, 5, 0, 10] },
    footer: {
      columns: [
        { text: 'Gerado automaticamente', alignment: 'left', fontSize: 8 },
        { text: moment().format('DD/MM/YYYY HH:mm'), alignment: 'right', fontSize: 8 },
      ],
    },
    content: [
      {
        table: {
          widths: [50, '*'],
          body: [
            [
              { image: imageData, width: 80, border: [false, false, false, false] },
              {
                text: 'Relatório de Estoque',
                fontSize: 20,
                bold: true,
                alignment: 'center',
                margin: [0, 15, 0, 0],
                border: [false, false, false, false],
              },
            ],
          ],
        },
      },
      { text: `Fábrica: ${nome}`, fontSize: 10, margin: [0, 1, 0, 10] },
      {
        table: {
          widths: [70, 70, 180, 60, 70, 50],
          body: [
            [
              { text: 'Codigo de Barra', alignment: 'left', fillColor: '#dddddd', fontSize: 8, bold: true },
              { text: 'Codigo da Fabrica', alignment: 'left', fillColor: '#dddddd', fontSize: 8, bold: true },
              { text: 'Descrição', alignment: 'center', fillColor: '#dddddd', fontSize: 8, bold: true },
              { text: 'Quantidade', alignment: 'center', fillColor: '#dddddd', fontSize: 8, bold: true },
              { text: 'Preço', alignment: 'center', fillColor: '#dddddd', fontSize: 8, bold: true },
              { text: 'Total', alignment: 'center', fillColor: '#dddddd', fontSize: 8, bold: true },
            ],
            ...vendas,
           


          ],
        },
      },
      // CONTAINER DOS TOTAIS (FAIXA + CARDS POR CIMA)
// FAIXA DE TOTAIS COLADA NA TABELA
// FAIXA FINAL DE TOTAIS — AJUSTADA
{
  margin: [0, 2, 0, 0], // colada na tabela
  table: {
    widths: ['*'],
    body: [
      [
        {
          fillColor: '#eeeeee',
          border: [false, false, false, false],
          margin: [14, 10, 14, 10], // faixa mais baixa
          table: {
            widths: ['*', '*', '*'],
            body: [
              [
                // TOTAL DE ITENS
                {
                  stack: [
                    {
                      text: 'TOTAL DE ITENS',
                      fontSize: 8,
                      color: '#777',
                      letterSpacing: 0.4,
                    },
                    {
                      text: TItens.toString(),
                      fontSize: 14,
                      bold: true,
                      margin: [0, 3, 0, 0],
                    },
                  ],
                  alignment: 'center',
                  border: [false, false, false, false],
                },

                // QUANTIDADE TOTAL
                {
                  stack: [
                    {
                      text: 'QUANTIDADE TOTAL',
                      fontSize: 8,
                      color: '#777',
                      letterSpacing: 0.4,
                    },
                    {
                      text: new Intl.NumberFormat('pt-BR', {
                        minimumFractionDigits: 2,
                      }).format(TQuantidade),
                      fontSize: 14,
                      bold: true,
                      margin: [0, 3, 0, 0],
                    },
                  ],
                  alignment: 'center',
                  border: [false, false, false, false],
                },

                // VALOR TOTAL
                {
                  stack: [
                    {
                      text: 'VALOR TOTAL',
                      fontSize: 8,
                      color: '#777',
                      letterSpacing: 0.4,
                    },
                    {
                      text: new Intl.NumberFormat('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      }).format(TValorVendas),
                      fontSize: 14,
                      bold: true,
                      margin: [0, 3, 0, 0],
                    },
                  ],
                  alignment: 'center',
                  border: [false, false, false, false],
                },
              ],
            ],
          },
        },
      ],
    ],
  },
  layout: {
    hLineWidth: () => 0,
    vLineWidth: () => 0,
    paddingLeft: () => 0,
    paddingRight: () => 0,
    paddingTop: () => 0,
    paddingBottom: () => 0,
  },
}



    ],
  };

  const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
  pdfDocGenerator.open();
}

export default Relatorioestoque;
